import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-heart-plus",
  "use": "icon-si-glyph-heart-plus-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-heart-plus\" id=\"icon-si-glyph-heart-plus\"><title>154</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(0.000000, 1.000000)\" fill=\"#434343\"><rect x=\"11\" y=\"11\" width=\"4.958\" height=\"0.918\" class=\"si-glyph-fill\" /><rect x=\"13\" y=\"9\" width=\"0.918\" height=\"4.957\" class=\"si-glyph-fill\" /><path d=\"M11.917,7.958 L14.972,7.958 C15.577,6.823 15.969,5.527 15.969,4.062 C15.969,1.833 14.174,0.031 11.958,0.031 C10.045,0.031 8.447,1.379 8.047,3.179 C7.631,1.376 6.026,0.031 4.102,0.031 C1.865,0.031 0.052,1.855 0.052,4.103 C0.052,10.599 8.057,13.941 8.057,13.941 C8.057,13.941 8.842,13.617 9.917,12.967 L9.917,9.917 L11.917,9.917 L11.917,7.958 L11.917,7.958 Z\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-heart-plus.svg
// module id = VmNM
// module chunks = 62